import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Option } from 'effect';

import IconButton from '@mui/material/IconButton';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

import Tooltip from '@/components/mui/Tooltip';
import { useBankFeedConnectionSettingsLink } from '@/pages/company/BankFeedRoute/useBankFeedConnectionSettingsLink';

const tooltipDescriptor = {
  id: 'company.bankFeed.transactions.header.settings.tooltip',
  defaultMessage: 'Bank Feed Settings',
};

const SettingsButton: React.FC = () => {
  const intl = useIntl();
  const settingsLink = useBankFeedConnectionSettingsLink();

  return Option.match(settingsLink, {
    onNone: () => null,
    onSome: (to) => (
      <Tooltip t={tooltipDescriptor}>
        <IconButton
          color="primary"
          component={RouterLink}
          to={to}
          sx={{ ml: 'auto' }}
          aria-label={intl.formatMessage(tooltipDescriptor)}
        >
          <SettingsOutlinedIcon />
        </IconButton>
      </Tooltip>
    ),
  });
};

export default SettingsButton;
